import { Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, Text, useToast } from '@chakra-ui/react'
import { MatriculasInt } from '../../../../interfaces/MatriculasInt';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { useAuthContex } from '../../../../shared/context/user.context';
import { useMatriculasAlumno } from '../../../../shared/middlewares/matriculas.middleware';
import { useEffect, useState } from 'react';

interface Props {
    onClose: () => void;
    isOpen: boolean;
    handleDiploma: (matriculaId: string | undefined) => void;
    matricula: MatriculasInt;
    loading: boolean;
}

export default function InfoDiplomaModal({ isOpen, onClose, handleDiploma, matricula, loading }: Props) {
    const { user } = useAuthContex();
    const { matriculas } = useMatriculasAlumno({ user: user });
    const [matriaculaActual, setMatriculaActual] = useState<MatriculasInt>()
    const navigate = useNavigate();

    useEffect(() => {
        if (matriculas) {
            const matriculaActual = matriculas?.data?.find((m: MatriculasInt) => m?.id === matricula?.id)
            setMatriculaActual(matriculaActual)
        }
    }, [matriculas])

    return (
        <Modal
            size="2xl"
            onClose={onClose}
            isOpen={isOpen}
            isCentered
        >
            <ModalContent
                padding={"30px"}
                rounded="10px"
                bg="#FFFFFF"
                shadow={"0px 4px 10px rgba(0, 0, 0, 0.1)"}
            >
                <ModalCloseButton />
                
                <ModalHeader
                    display={"flex"}
                    flexDirection={"column"}
                    gap="10px"
                >
                    <Text color="font" fontSize="24px" fontWeight="600" lineHeight="normal">
                        Datos del diploma
                    </Text>

                    <Text
                        color="secondary"
                        fontSize="18px"
                        fontWeight="700"
                    >
                        ATENCIÓN: <Text as="span" color="font" fontSize="16px" fontWeight="400"> Revisa tus datos antes de generar el diploma definitivo.</Text>    
                    </Text>
                </ModalHeader>

                <ModalBody
                    display="flex"
                >
                    <Flex
                        flex="1"
                        direction="column"
                        gap="15px"
                    >
                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Curso:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{matriaculaActual?.grupo?.curso?.nombre}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Modalidad:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700" textTransform="capitalize">{matriaculaActual?.grupo?.modalidad}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Fecha de inicio:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{matriaculaActual?.grupo?.fechaInicio ? format(new Date(matriaculaActual?.grupo?.fechaInicio), "dd/MM/yyyy") : "---"}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Fecha de fin:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{matriaculaActual?.grupo?.fechaFin ? format(new Date(matriaculaActual?.grupo?.fechaFin), "dd/MM/yyyy") : "---"}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Código AF:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{matriaculaActual?.grupo?.accionFormativa}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Código Grupo:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{matriaculaActual?.grupo?.codigoGrupo}</Text>
                        </Flex>
                    </Flex>

                    <Flex
                        flex="1"
                        direction="column"
                        gap="15px"
                    >
                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Nombre:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{user?.nombre} {user?.apellidos}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">NIF:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{user?.dni}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Empresa:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{user?.empresa?.nombre}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">CIF:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{user?.empresa?.cif}</Text>
                        </Flex>

                        <Flex
                            gap="10px"
                        >
                            <Text color="font" fontSize="16px" fontWeight="400">Fecha de expedición:</Text>
                            <Text color="font" fontSize="16px" fontWeight="700">{matriaculaActual?.grupo?.fechaFin ? format(new Date(matriaculaActual?.grupo?.fechaFin), "dd/MM/yyyy") : "---"}</Text>
                        </Flex>
                    </Flex>
                </ModalBody>

                <ModalFooter gap="20px">
                    <Button
                        color="secondary"
                        bgColor="purewhite"
                        border={`2px solid `}
                        borderColor={"secondary"}
                        p="10px"
                        h="fit-content"
                        w="fit-content"
                        rounded="10px"
                        fontSize="16px"
                        fontWeight="600"
                        onClick={() => {
                            onClose();
                            navigate(`/perfil`)
                        }}
                        _hover={{ bgColor: "secondary_variant", borderColor: "secondary_variant", color: "purewhite" }}
                    >
                        Solicitar cambios
                    </Button>

                    <Button
                        isLoading={loading}
                        bg="secondary"
                        color="purewhite"
                        p="10px"
                        h="fit-content"
                        w="fit-content"
                        rounded="10px"
                        fontSize="16px"
                        fontWeight="600"
                        border={`2px solid `}
                        borderColor={"transparent"}
                        _hover={{ color: "purewhite", bgColor: "secondary_variant" }}
                        onClick={() => handleDiploma(matricula.id)}
                    >
                        Descargar
                    </Button>
                </ModalFooter>
            </ModalContent>

        </Modal>
    )
}
